<template>
  <div class="forum">
    <div class="bread" v-if="$identity.name == 'student'">
      <router-link :to="{ name: 'Community' }" v-if="origin == 2">
        圈子
      </router-link>
      <span @click="$router.go(-1)" v-else class="breadName">班级圈子</span>
      <span class="slash">/</span>
      <span class="current">发表帖子</span>
    </div>
    <div class="comment-box">
      <el-form
        :model="postForm"
        :rules="rules"
        ref="postForm"
        class="demo-ruleForm"
        label-width="80px"
      >
        <div class="block" v-if="isShowPlate">
          <el-form-item prop="plate_id" label="选择版块">
            <el-select
              v-model="postForm.plate_id"
              placeholder="请选择"
              size="medium"
            >
              <el-option
                v-for="item in blocks"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item
          required
          class="title"
          label="帖子标题"
          v-if="origin == 2"
        >
          <el-form-item prop="title">
            <el-input
              v-model="postForm.title"
              maxlength="100"
              placeholder="请输入标题"
            ></el-input>
            <span class="titleLength">{{ maxTitleLength }}/100</span>
          </el-form-item>
        </el-form-item>
        <el-form-item prop="content" class="content-box" label="帖子内容">
          <el-input
            type="textarea"
            :autosize="{ minRows: 16 }"
            placeholder="请输入内容"
            v-model="postForm.content"
            style="width: 1070px"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="videoInfo"
          class="videoButton"
          v-if="pageType == 2"
          label="上传视频"
        >
          <div class="videoWrap">
            <UploadOSSFile
              @onSuccess="onUploadSuccess"
              :format="format"
              :max-size="200 * 1024"
              style="display: inline"
            >
              <div class="imgBtnWrap">
                <div class="wrapInfo">
                  <img src="~@/assets/images/icon-video.png" alt="" />
                  <p>上传视频</p>
                </div>
              </div>
            </UploadOSSFile>
            <div v-if="postForm.videoInfo.ware_url" class="videoInfo">
              <video
                :src="postForm.videoInfo.ware_url"
                class="videoDom video video-js vjs-default-skin"
              ></video>
              <span class="iconDelete" @click="deleteVideo">
                <i class="el-icon-close"></i>
              </span>
            </div>
          </div>
          <p class="tip">视频大小不能超过200MB</p>
        </el-form-item>
        <el-form-item
          prop="imgInfo"
          class="videoButton"
          v-else
          label="上传图片"
        >
          <div class="videoWrap">
            <UploadOSSFile
              @onSuccess="onUploadImageSuccess"
              :format="imgFormat"
              style="display: inline"
            >
              <div class="imgBtnWrap">
                <div class="wrapInfo">
                  <img src="~@/assets/images/icon-image.png" alt="" />
                  <p>上传图片</p>
                </div>
              </div>
            </UploadOSSFile>
            <template v-if="postForm.imgInfo.length">
              <div
                class="videoInfo"
                v-for="(item, index) in postForm.imgInfo"
                :key="item"
              >
                <img
                  :src="item"
                  class="videoDom video video-js vjs-default-skin"
                />
                <span class="iconDelete" @click="deleteImg(index)">
                  <i class="el-icon-close"></i>
                </span>
              </div>
            </template>
          </div>
          <p class="tip">最多上传30张</p>
        </el-form-item>
        <el-form-item label="验证码" class="code-box">
          <div class="box">
            <div class="code">
              <el-form-item prop="code">
                <el-input
                  v-model="postForm.code"
                  placeholder="请输入验证码"
                ></el-input>
              </el-form-item>
              <img class="code-img" :src="imgCode.img" @click="getImgCode" />
            </div>
            <button
              class="comment-submit"
              type="button"
              @click="submitForm('postForm')"
            >
              发表帖子
            </button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import UploadOSSFile from "../UploadOSSFile.vue";
export default {
  name: "CommunityPost",
  components: {
    UploadOSSFile,
  },
  data() {
    return {
      format: ["mp4", "avi", "flv", "wmv", "mov", "rmvb"], //视频上传的类型控制
      imgFormat: ["jpg", "jpeg", "png", "gif", "webp", "svg"], //图片上传的类型控制
      circleId: "",
      blocks: [], //版块
      pageType: "", //图文帖子还是视频帖子1 图片 2视频
      myGroup: [], //我的小组列表
      myVue: this,
      imgCode: {}, // 验证码图片
      postForm: {
        videoInfo: "",
        plate_id: "",
        title: "",
        content: "",
        code: "",
        imgInfo: [],
      }, //发帖信息
      rules: {
        plate_id: [
          {
            required: true,
            message: "请选择板块",
            trigger: "change",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入话题名称",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        videoInfo: [
          {
            required: true,
            message: "请上传视频",
            trigger: "blur",
          },
        ],
        imgInfo: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
          },
        ],
        anonymous: [
          {
            required: true,
            message: "请选择是否匿名",
            trigger: "blur",
          },
        ],
      }, //发帖验证
      origin: 1, //2:社区 1:班级圈子
      community_setting: {}, //社区参数
    };
  },
  created() {
    const pageType = this.$route.query.type || 1;
    this.circleId = this.$route.query.id;
    this.pageType = pageType;
    this.origin = this.$route.query.origin;
    // this.getMineGroup();
    this.getImgCode();
    this.getBlock();
    this.getPlateStatus();
  },
  mounted: function () {},
  computed: {
    maxTitleLength() {
      return 100 - this.postForm.title.length;
    },
    isShowPlate() {
      if (this.origin == 2) {
        return this.community_setting.is_open_like_plate == 1;
      } else {
        return this.community_setting.is_open_class_plate == 1;
      }
    },
  },
  watch: {
    async isShowPlate(value) {
      await this.$nextTick();
      value && this.checkPlate();
    },
  },
  methods: {
    checkPlate() {
      if (this.blocks.length == 0) {
        this.$refs.postForm.validateField("plate_id");
      }
    },
    // 获取版块开启状态
    getPlateStatus() {
      this.$http.get(`/api/app/config/community_setting`).then(res => {
        this.community_setting = res.community_setting;
      });
    },
    //班级获取版块  社区获取兴趣版块
    getBlock() {
      if (this.origin == 2) {
        this.$http
          .get(
            `/api/${this.$identity.getCommunityClientApiLetter()}/community/plate`,
            { group_id: this.circleId },
          )
          .then(res => {
            this.blocks =
              res.plates.filter(item => {
                return item.who_can_post.includes(
                  this.$identity.getPlateIdentity(),
                );
              }) || [];
            this.checkPlate();
          });
      } else {
        //获取版块列表
        this.$http
          .get(
            `/api/${this.$identity.getCommunityClientApiLetter()}/community/plate`,
          )
          .then(res => {
            this.blocks =
              res.filter(item => {
                return item.who_can_post.includes(
                  this.$identity.getPlateIdentity(),
                );
              }) || [];
            this.checkPlate();
          });
      }
    },
    // 获取图形验证码
    async getImgCode() {
      const that = this;
      let data = await that.$http.get(`/api/app/captcha`);
      that.imgCode = data;
    },
    // 编辑器失去焦点事件
    onEditorBlur() {
      if (this.postForm.content) {
        this.$refs.postForm.clearValidate("content");
      }
    },
    //发表帖子
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate(async valid => {
        if (valid) {
          let params = {};
          if (this.pageType == 1) {
            //图片
            params = {
              group_id: that.circleId,
              title: that.postForm.title,
              content: that.postForm.content,
              plate_id: that.postForm.plate_id ? that.postForm.plate_id : 10,
              resource_type: that.pageType, //1是图片 2是视频
              captcha: that.postForm.code,
              key: that.imgCode.key,
              resources: this.postForm.imgInfo,
            };
          } else if (this.pageType == 2) {
            //视频
            params = {
              group_id: that.circleId,
              title: that.postForm.title,
              content: that.postForm.content,
              plate_id: that.postForm.plate_id ? that.postForm.plate_id : 10,
              resource_type: that.pageType, //1是图片 2是视频
              captcha: that.postForm.code,
              key: that.imgCode.key,
              resources: [this.postForm.videoInfo.ware_url],
            };
          }
          let data = await that.$http.post(
            `/api/${this.$identity.getCommunityClientApiLetter()}/community/post`,
            params,
          );
          that.$message({
            type: "success",
            message: "发帖成功！",
            duration: 1000,
            onClose: () => {
              that.$router.replace({
                name: "CommunityDetail",
                params: {
                  id: data,
                  group_id: that.circleId,
                  // plate_id: item.plate_id,
                  type: this.origin,
                },
              });
            },
          });
          that.getImgCode();
        } else {
          return false;
        }
      });
    },
    //视频上传成功的回调
    onUploadSuccess(data) {
      this.postForm.videoInfo = {
        ware_filename: data.originalName,
        ware_name: data.originalName,
        ware_url: data.path,
      };
    },
    //视频删除
    deleteVideo() {
      this.postForm.videoInfo = "";
    },
    //图片上传成功的回调
    onUploadImageSuccess(data) {
      if (this.postForm.imgInfo.length > 30) {
        this.$error("最多上传30张");
        return;
      }
      this.postForm.imgInfo.push(data.path);
    },
    //图片删除
    deleteImg(index) {
      this.postForm.imgInfo.splice(index, 1);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.forum {
  padding-bottom: 24px;
  background-color: #f5f7f9;
  overflow: hidden;
  .bread {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
    .breadName {
      cursor: pointer;
    }
  }
  .comment-box {
    margin-top: 20px;
    padding-top: 20px;
    background-color: #fff;
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    .block {
      background-color: #fff;
      padding: 0 0 20px 24px;
      /deep/ .el-form-item {
        margin-bottom: 0;
      }
    }
    .videoButton {
      background-color: #fff;
      padding: 0 24px;
      .iconDelete {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        opacity: 0.3;
        background: #000000;
        border-radius: 0px 3px 0px 4px;
        color: #fff;
        z-index: 999;
      }
      .el-icon-close:hover {
        color: $primary-color;
      }
      .note {
        color: #999;
        margin-left: 10px;
        display: inline-block;
      }
      .tip {
        color: #999;
        margin-top: 9px;
      }
      .videoWrap {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .videoInfo {
          width: 104px;
          height: 104px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ffffff;
          border: 1px solid rgba(0, 0, 0, 0.15);
          border-radius: 5px;
          position: relative;
          margin-left: 12px;
          .videoDom {
            width: 88px;
            height: 88px;
          }
        }
        .imgBtnWrap {
          width: 104px;
          height: 104px;
          text-align: center;
          background: rgba(0, 0, 0, 0.02);
          border: 1px dashed rgba(0, 0, 0, 0.15);
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: normal;
          cursor: pointer;
          .wrapInfo {
            img {
              width: 27px;
              height: 27px;
            }
            p {
              color: #666666;
              font-size: 14px;
              line-height: normal;
            }
          }
        }
      }
    }
    .title {
      margin: 0 auto;
      padding: 0 24px 30px;
      background-color: #fff;
      .titleLength {
        position: absolute;
        right: 7px;
        color: #ccc;
        background: #fff;
        height: 36px;
        margin-top: 0px;
        line-height: 36px;
        margin-top: 2px;
        padding-left: 5px;
      }
    }
    .el-form-item {
      margin-bottom: 0 !important;
    }
    .content-box {
      padding: 0 24px 24px;
      background-color: #fff;
    }
    .group {
      margin: 0 0 30px;
      padding: 30px 24px;
      background-color: #fff;
      .label {
        font-size: 16px;
        color: #20242a;
        line-height: 16px;
      }
      .group-list {
        padding: 30px 26px 0;
        overflow: hidden;
        li {
          float: left;
          height: 34px;
          margin-bottom: 30px;
          margin-right: 40px;
          padding: 0 20px;
          background-color: #f4f4f4;
          border-radius: 15px;
          text-align: center;
          font-size: 16px;
          color: #595959;
          line-height: 34px;
          cursor: pointer;
        }
        .active {
          position: relative;
          background-color: #d9d9d9;
          &:after {
            position: absolute;
            top: -3px;
            right: -3px;
            display: block;
            width: 16px;
            height: 16px;
            background: url("~@/assets/images/icon_fourm_group_check.png")
              center no-repeat rgba(0, 0, 0, 0.1);
            background-size: 16px 16px;
            border-radius: 50%;
            z-index: 999;
            content: "";
          }
        }
      }
    }
    .code-box {
      background-color: #fff;
      padding: 24px;
      .box {
        .code {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .code-img {
            margin-left: 15px;
          }
        }
        .comment-submit {
          display: block;
          width: 96px;
          height: 36px;
          border: none;
          background-color: $primary-color;
          cursor: pointer;
          border-radius: 4px;
          text-align: center;
          font-size: 14px;
          color: #fff;
          line-height: 36px;
          outline: none;
          margin-top: 24px;
        }
      }
    }
  }
}
</style>
